import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([[_ctx.isLoading ? 'd-flex' : 'd-none'], "overlay justify-content-center align-items-center"])
  }, _cache[0] || (_cache[0] = [
    _createElementVNode("div", {
      class: "spinner-border",
      style: {"width":"3rem","height":"3rem"},
      role: "status"
    }, [
      _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
    ], -1)
  ]), 2))
}